import React from "react";

const Resources = () => {
  const mainWrapper = {
    backgroundColor: "#05070a",
    color: "#ffffff",
    minHeight: "100vh",
    paddingTop: "120px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    overflowX: "hidden",
  };

  const container = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  };

  const glassCard = {
    background: "rgba(255, 255, 255, 0.03)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "24px",
    padding: "35px",
    backdropFilter: "blur(10px)",
    height: "100%",
  };

  return (
    <div style={mainWrapper}>
      {/* SECTION 1: HEADER */}
      <section style={container}>
        <div style={{ textAlign: "center", marginBottom: "90px" }}>
          <h4
            style={{
              color: "#00d4ff",
              letterSpacing: "3px",
              textTransform: "uppercase",
              marginBottom: "15px",
              fontWeight: "bold",
            }}
          >
            Resource Augmentation & Delivery
          </h4>

          <h1
            style={{
              fontSize: "clamp(2.4rem, 5vw, 4rem)",
              fontWeight: "800",
              marginBottom: "25px",
            }}
          >
            Technology Resources <br />
            <span style={{ color: "#00d4ff" }}>Ready to Deploy</span>
          </h1>

          <p
            style={{
              fontSize: "1.15rem",
              color: "#8b949e",
              maxWidth: "900px",
              margin: "0 auto",
              lineHeight: "1.8",
            }}
          >
            Digital-X-AI provides highly skilled, enterprise-ready technology
            resources to support mission-critical programs. Our engagement
            models are designed for flexibility, speed, and long-term value.
            We work as an extension of your delivery team.
          </p>
        </div>

        <div
          style={{
            borderRadius: "40px",
            overflow: "hidden",
            border: "1px solid #30363d",
            marginBottom: "110px",
          }}
        >
          <img
            src="https://images.unsplash.com/photo-1535223289827-42f1e9919769?auto=format&fit=crop&w=1600&q=80"
            alt="Enterprise IT Resources"
            style={{ width: "100%", height: "480px", objectFit: "cover" }}
          />
        </div>
      </section>

      {/* SECTION 2: DELIVERY MODEL */}
      <section style={{ background: "#090c10", padding: "110px 0" }}>
        <div
          style={{
            ...container,
            display: "flex",
            gap: "70px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 1, minWidth: "350px" }}>
            <h2 style={{ fontSize: "2.7rem", marginBottom: "25px" }}>
              Global <span style={{ color: "#00d4ff" }}>Delivery Model</span>
            </h2>
            <p style={{ color: "#8b949e", fontSize: "1.1rem", lineHeight: "1.9" }}>
              Our primary engineering and delivery operations are based in
              India, supported by active engagements and coordination across
              the Middle East and global regions. This model allows us to offer
              scalability, cost efficiency, and consistent delivery quality.
            </p>
            <p style={{ color: "#8b949e", fontSize: "1.1rem", lineHeight: "1.9" }}>
              Digital-X-AI operates as a trusted sub-contracting and delivery
              partner for enterprises, system integrators, and cloud service
              providers.
            </p>
          </div>

          <div style={{ flex: 1, minWidth: "350px" }}>
            <img
              src="https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=800&q=80"
              alt="Global Delivery Team"
              style={{
                width: "100%",
                borderRadius: "30px",
                border: "1px solid #30363d",
              }}
            />
          </div>
        </div>
      </section>

      {/* SECTION 3: RESOURCE CATEGORIES */}
      <section style={{ ...container, padding: "120px 0" }}>
        <h2
          style={{
            textAlign: "center",
            fontSize: "3rem",
            marginBottom: "70px",
          }}
        >
          Our Resource Capabilities
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "28px",
          }}
        >
          <div style={glassCard}>
            <h4 style={{ color: "#00d4ff", fontSize: "1.4rem" }}>
              Cloud Engineers
            </h4>
            <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
              Certified professionals across Google Cloud, IBM Cloud, AWS, and
              hybrid environments, supporting migrations, optimization, and
              enterprise workloads.
            </p>
          </div>

          <div style={glassCard}>
            <h4 style={{ color: "#00d4ff", fontSize: "1.4rem" }}>
              Integration Specialists
            </h4>
            <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
              Experts in API-led integration, middleware platforms, enterprise
              messaging, and system orchestration for complex environments.
            </p>
          </div>

          <div style={glassCard}>
            <h4 style={{ color: "#00d4ff", fontSize: "1.4rem" }}>
              AI & Automation Resources
            </h4>
            <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
              Machine learning engineers, automation specialists, and data
              engineers supporting intelligent systems and operational
              efficiency.
            </p>
          </div>

          <div style={glassCard}>
            <h4 style={{ color: "#00d4ff", fontSize: "1.4rem" }}>
              Enterprise Support Teams
            </h4>
            <p style={{ color: "#8b949e", lineHeight: "1.8" }}>
              L2 and L3 support engineers providing production support,
              performance tuning, and operational stability for critical
              platforms.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: ENGAGEMENT MODELS */}
      <section style={{ background: "#090c10", padding: "100px 0" }}>
        <div style={container}>
          <h2 style={{ fontSize: "2.6rem", marginBottom: "30px" }}>
            Flexible Engagement Models
          </h2>
          <p style={{ color: "#8b949e", fontSize: "1.1rem", lineHeight: "1.9" }}>
            We support multiple engagement models including dedicated resources,
            time-and-materials, fixed-scope delivery, and hybrid delivery
            structures. Our goal is to align with your business priorities,
            timelines, and operational requirements.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Resources;